interface InfoFieldProps {
  label: string
  value: string | number | null | undefined
}

export default function InfoField({ label, value }: InfoFieldProps) {
  /**
   * Returns "Not Added" if the value is null, undefined, or an empty string.
   * Otherwise returns the original value.
   */
  function getValueOrNotAdded<T>(value: T | null | undefined): string | T {
    if (value === null || value === undefined || value === '') {
      return 'Not Added'
    }
    return value
  }

  const displayValue = getValueOrNotAdded(value)

  return (
    <div>
      <div className={'text-gray-600 text-sm font-normal'}>{label}</div>
      <div className={'text-gray-800 text-lg font-medium'}>{displayValue}</div>
    </div>
  )
}
